import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Table, Row, Col } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { BASE_URL } from '../../../constants';
import { FaTimes } from 'react-icons/fa';

function EditArea(props) {
    const [errMsg, setErrMsg] = useState(null);
    const [title, setTitle] = useState('');
    const [isCommon, setIsCommon] = useState(0);
    const [isEdited, setIsEdited] = useState(false);
    const [showAddItemPopup, setShowAddItemPopup] = useState(false);
    const [itemName, setItemName] = useState('');
    const [editItemName, setEditItemName] = useState('');
    const [editItem, setEditItem] = useState(null);
    const [showEditItemPopup, setShowEditItemPopup] = useState(false);
    const [areaItems, setAreaItems] = useState([]);
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    const fetchAreaItems = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Authorization token is missing.');
            }

            const response = await axios.get(`${BASE_URL}/area/item/all/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setAreaItems(response.data.result);
        } catch (error) {
            console.error('Error fetching area items:', error);
        }
    };

    useEffect(() => {
        fetchAreaItems();
    }, [id]);

    useEffect(() => {
        const area = location.state?.areas.find(area => area.id === parseInt(id));
        if (area) {
            setTitle(area.title);
            setIsCommon(area.is_common);
            // setIsCustom(area.is_custom);
        }
    }, [id, location.state?.areas]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Authorization token is missing.');
            }

            const response = await axios.put(`${BASE_URL}/area/update/${id}`, {
                title,
                is_common: isCommon,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setErrMsg(response.data.message);
            setIsEdited(true);
        } catch (error) {
            setErrMsg('Error editing area. Please try again.');
        }

    };

    const handleAddItem = async () => {
        if (itemName.trim() !== '') {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('Authorization token is missing.');
                }

                const response = await axios.post(`${BASE_URL}/area/item/add/${id}`, {
                    name: itemName.trim()
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                console.log(response.data, 'play')
                if (Array.isArray(areaItems)) {
                    setAreaItems([...areaItems, response.data.result]);
                } else {
                    setAreaItems([response.data.result]);
                }
                setItemName('');
                setShowAddItemPopup(false);
            } catch (error) {
                console.error('Error adding area item:', error);
            }
        }
    };

    if (isEdited) {
        navigate('/area');
    }
    const handleEdit = (item) => {

        setEditItem(item);
        setEditItemName(item.name);
        setShowEditItemPopup(true);
    };

    const handleEditItem = async () => {
        // Make sure editItem is not null and contains valid data
        if (editItem && editItem.id && editItemName.trim() !== '') {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('Authorization token is missing.');
                }

                const response = await axios.put(`${BASE_URL}/area/item/update/${id}/${editItem.id}`, {
                    name: editItemName.trim()
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                const updatedItem = { ...editItem, name: editItemName.trim() };
                const updatedAreaItems = areaItems.map(item => (item.id === updatedItem.id ? updatedItem : item));
                setAreaItems(updatedAreaItems);

                setShowEditItemPopup(false);
            } catch (error) {
                console.error('Error editing area item:', error);
            }
        }
    };

    const handleDelete = async (itemId) => {
        const confirmed = window.confirm("Are you sure you want to delete this amenity?");

        // If user confirms deletion
        if (confirmed) {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('Authorization token is missing.');
                }

                const response = await axios.delete(`${BASE_URL}/area/item/delete/${itemId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setErrMsg(response.data.message);
                fetchAreaItems();

            } catch (error) {
                setErrMsg('Error deleting amenity. Please try again.');
            }
        }
    }

    return (
        <div className="content">
            {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

            <h4 className="mt-0">Edit amenity</h4>

            <Card>
                <CardBody>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                            <Label for="title">Title*</Label>
                            <Input type="text" name="title" id="title" value={title} onChange={(e) => setTitle(e.target.value)} />
                        </FormGroup>
                        <div style={{ paddingLeft: '10px', paddingRight: '10px', marginTop: '10px' }}>
                            <Label check>
                                <Input type="checkbox" checked={isCommon} onChange={(e) => setIsCommon(e.target.checked ? 1 : 0)} />{' '}
                                Is Common
                            </Label>
                        </div>
                        <Button color="primary" type="submit">Submit</Button>
                    </Form>
                </CardBody>
            </Card>

            <Modal isOpen={showAddItemPopup} toggle={() => setShowAddItemPopup(!showAddItemPopup)} centered size="md">
                <ModalHeader toggle={() => setShowAddItemPopup(!showAddItemPopup)} style={{ display: 'flex', justifyContent: 'space-between' }}
                    close={
                        <button className="close" onClick={() => setShowAddItemPopup(!showAddItemPopup)} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
                            <FaTimes size={20} />
                        </button>
                    }>Add Area Item</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="itemName">Item Name</Label>
                            <Input type="text" name="itemName" id="itemName" value={itemName} onChange={(e) => setItemName(e.target.value)} />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAddItem}>Confirm</Button>{' '}
                    <Button color="secondary" onClick={() => setShowAddItemPopup(!showAddItemPopup)}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={showEditItemPopup} toggle={() => setShowEditItemPopup(!showEditItemPopup)}>
                <ModalHeader toggle={() => setShowEditItemPopup(!showEditItemPopup)} style={{ display: 'flex', justifyContent: 'space-between' }}
                 close={
                    <button className="close" onClick={() => setShowEditItemPopup(!showEditItemPopup)} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
                        <FaTimes size={20} />
                    </button>
                } >Edit Amenity Item</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="editItemName">Item Name</Label>
                            <Input type="text" name="editItemName" id="editItemName" value={editItemName} onChange={(e) => setEditItemName(e.target.value)} />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleEditItem}>Confirm</Button>{' '}
                    <Button color="secondary" onClick={() => setShowEditItemPopup(!showEditItemPopup)}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <Row>
                <Col xs="6">
                    <h4 className="mt-0">Amenity Items</h4>
                </Col>

                <Col xs="6" className="text-end">
                    <Button color="primary" onClick={() => setShowAddItemPopup(true)}>Add Amenity Item</Button>
                </Col>
            </Row>

            <Card>
                <CardBody>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {areaItems && areaItems.map((item, index) => (
                                <tr key={item.id}>
                                    <th scope="row">{index + 1}</th>
                                    <td>{item.name}</td>
                                    <td>
                                        <Button color="primary" size="sm" onClick={() => handleEdit(item)}>Edit</Button>{' '}
                                        <Button color="danger" size="sm" onClick={() => handleDelete(item.id)}>Delete</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </CardBody>
            </Card>


        </div>
    );
}

export default EditArea;
